/*
 * Minimal, safe service-worker registration for the ODRA customer app.
 *
 * Deliberately conservative:
 *  - Registers only in the browser, over https/localhost.
 *  - Does NOT auto-reload the page on update (would risk interrupting a
 *    guest mid-order). New versions apply naturally on the next load,
 *    helped by the worker's network-first navigation.
 */
export function register() {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;

  const isLocalhost = ['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname);
  const isSecure = window.location.protocol === 'https:' || isLocalhost;
  if (!isSecure) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .catch((err) => {
        // Never let a registration failure break the app.
        console.warn('SW registration failed (app still works):', err);
      });
  });
}

export function unregister() {
  if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((reg) => reg.unregister()).catch(() => {});
  }
}
